import { pipe } from 'ramda';
import withComponentForm from '#components/pages/Components/Component/support/Router/withSectionFunctionality/withComponentForm/index.js';

const withSectionFunctionality = C => pipe(withComponentForm)(C);

export default withSectionFunctionality;
